import { render, staticRenderFns } from "./footer-download.vue?vue&type=template&id=1a395848&scoped=true&"
import script from "./footer-download.vue?vue&type=script&lang=js&"
export * from "./footer-download.vue?vue&type=script&lang=js&"
import style0 from "./footer-download.vue?vue&type=style&index=0&id=1a395848&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a395848",
  null
  
)

export default component.exports